const ExpandIcon = ({style}) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect
        x="0.5"
        y="0.974609"
        width="23"
        height="23.0928"
        rx="11.5"
        fill="#0A0A0A"
      />
      <rect
        x="0.5"
        y="0.974609"
        width="23"
        height="23.0928"
        rx="11.5"
        stroke="#313131"
      />
      <path
        d="M10.25 15.9746L13.1902 13.0344C13.4541 12.7705 13.586 12.6386 13.586 12.4746C13.586 12.3106 13.4541 12.1787 13.1902 11.9148L10.25 8.97461"
        stroke="white"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ExpandIcon;
